module.exports = __webpack_public_path__ + "static/media/ico-denuncia.baa6280b.svg";